/**
 * @generated SignedSource<<8228efb9445dc64ba7db64ffc9c1baf4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ActivityTimelineItem_activity$data = {
  readonly __typename: "MessageActivity";
  readonly id: string;
  readonly createdAt: string;
  readonly body: string;
  readonly bodyHtml: string | null;
  readonly direction: string | null;
  readonly authorType: string;
  readonly author: {
    readonly id: string;
    readonly fullName: string | null;
  } | null;
  readonly deliveryStatus: string | null;
  readonly retryCount: number;
  readonly attachments: ReadonlyArray<{
    readonly id: string;
    readonly filename: string;
    readonly contentType: string;
    readonly sizeBytes: number;
    readonly inlineContentId: string | null;
    readonly downloadUrl: string;
  }>;
  readonly " $fragmentType": "ActivityTimelineItem_activity";
} | {
  readonly __typename: "InternalCommentActivity";
  readonly id: string;
  readonly createdAt: string;
  readonly body: string;
  readonly author: {
    readonly id: string;
    readonly fullName: string | null;
  } | null;
  readonly mentionedUsers: ReadonlyArray<{
    readonly id: string;
    readonly fullName: string | null;
  }>;
  readonly " $fragmentType": "ActivityTimelineItem_activity";
} | {
  readonly __typename: "EventActivity";
  readonly id: string;
  readonly createdAt: string;
  readonly eventType: string;
  readonly actor: {
    readonly id: string;
    readonly fullName: string | null;
  } | null;
  readonly oldValue: string | null;
  readonly newValue: string | null;
  readonly " $fragmentType": "ActivityTimelineItem_activity";
} | {
  readonly __typename: "AttachmentActivity";
  readonly id: string;
  readonly createdAt: string;
  readonly filename: string;
  readonly contentType: string;
  readonly sizeBytes: number;
  readonly downloadUrl: string;
  readonly " $fragmentType": "ActivityTimelineItem_activity";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "ActivityTimelineItem_activity";
};
export type ActivityTimelineItem_activity$key = {
  readonly " $data"?: ActivityTimelineItem_activity$data;
  readonly " $fragmentSpreads": FragmentRefs<"ActivityTimelineItem_activity">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v3 = [
  (v0/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullName",
    "storageKey": null
  }
],
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "Person",
  "kind": "LinkedField",
  "name": "author",
  "plural": false,
  "selections": (v3/*: any*/),
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "filename",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentType",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sizeBytes",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "downloadUrl",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ActivityTimelineItem_activity",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bodyHtml",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "direction",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "authorType",
          "storageKey": null
        },
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "deliveryStatus",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "retryCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MessageAttachment",
          "kind": "LinkedField",
          "name": "attachments",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "inlineContentId",
              "storageKey": null
            },
            (v8/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "type": "MessageActivity",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v2/*: any*/),
        (v4/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Person",
          "kind": "LinkedField",
          "name": "mentionedUsers",
          "plural": true,
          "selections": (v3/*: any*/),
          "storageKey": null
        }
      ],
      "type": "InternalCommentActivity",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "eventType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Person",
          "kind": "LinkedField",
          "name": "actor",
          "plural": false,
          "selections": (v3/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "oldValue",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "newValue",
          "storageKey": null
        }
      ],
      "type": "EventActivity",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/),
        (v7/*: any*/),
        (v8/*: any*/)
      ],
      "type": "AttachmentActivity",
      "abstractKey": null
    }
  ],
  "type": "ActivityEvent",
  "abstractKey": "__isActivityEvent"
};
})();

(node as any).hash = "a4238887443061743a677ea4bf44e5ca";

export default node;
